// Game-specific scene configuration
import { SceneModeManagerConfig } from '@/engine/scene/SceneManager';
import { appMode } from '@/stores/ui/appState';
import { SceneEditorScene } from '@/scene-editor/scene/SceneEditorScene';

/**
 * Конфигурация сцен для игры
 */
export const gameSceneConfig: SceneModeManagerConfig<'scene-editor' | 'game' | 'auto-battle'> = {
  modeStore: appMode,
  defaultMode: 'game',
  scenes: [
    {
      mode: 'scene-editor',
      sceneFactory: () => new SceneEditorScene(),
      sceneType: SceneEditorScene,
    },
    {
      mode: 'game',
      sceneFactory: async () => {
        const { DynamicMiningScene } = await import('../scenes/DynamicMiningScene');
        return new DynamicMiningScene();
      },
      sceneType: null, // Не можем указать тип для динамического импорта
    },
    {
      mode: 'auto-battle',
      sceneFactory: async () => {
        const { AutoBattleScene } = await import('../scenes/AutoBattleScene');
        return new AutoBattleScene();
      },
      sceneType: null, // Не можем указать тип для динамического импорта
    },
  ],
};
